import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import News from './pages/News';
import Team from './pages/Team';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import FinancialAnalyzer from './pages/FinancialAnalyzer';

// Auth Pages
import Login from './pages/Login';
import SignUp from './pages/Signup';

// Protected Pages
import Investor from './dashboard/Investor';
import Profile from './dashboard/Profile';
import KYC from './dashboard/Kyc';

// Payment Components
import PaymentMethod from './components/payments/PaymentMethod';
import PaymentSuccess from './components/payments/PaymentSuccess';
import PaymentCancel from './components/payments/PaymentCancel';

// Context and Styles
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

// PayPal Configuration
const paypalOptions = {
  'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID || 'test', // Fallback for development
  currency: 'USD',
  intent: 'capture',
  components: 'buttons,funding-eligibility',
  'disable-funding': 'credit,card',
  'enable-funding': 'venmo,paylater',
  'data-order-id': '',
  'data-partner-attribution-id': 'SWANPOINT_SP_PPCP'
};


function ProtectedRoute({ children }) {
  const isAuthenticated = localStorage.getItem('token');
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <PayPalScriptProvider options={paypalOptions}>
        <Router>
          <div className="App">
            <Header />
            <main>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/news" element={<News />} />
                <Route path="/team" element={<Team />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/financial-analyzer" element={<FinancialAnalyzer />} />
                <Route path="/contact" element={<Contact />} />

                {/* Protected Routes */}
                <Route path="/investor" element={
                  <ProtectedRoute>
                    <Investor />
                  </ProtectedRoute>
                } />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                <Route path="/kyc" element={
                  <ProtectedRoute>
                    <KYC />
                  </ProtectedRoute>
                } />
                <Route path="/payment" element={
                  <ProtectedRoute>
                    <PaymentMethod />
                  </ProtectedRoute>
                } />
                {/* Add payment success and cancel routes */}
                <Route path="/payment/success" element={
                  <ProtectedRoute>
                    <PaymentSuccess status="success" />
                  </ProtectedRoute>
                } />
                <Route path="/payment/cancel" element={
                  <ProtectedRoute>
                    <PaymentCancel status="cancelled" />
                  </ProtectedRoute>
                } />
                
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </PayPalScriptProvider>
    </AuthProvider>
  );
}

export default App;